'use client';

import React, { useState } from 'react';
import {useRouter} from 'next/navigation';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import {radio} from '@nextui-org/react';

const Interestform = () => {
  const [step, setStep] = useState(1);
  const [show, setShow] = useState(false);
  const router = useRouter();
  const intialFormData = {
    name: '',
    email: '',
    mobile: '',
    time: '',
    agent_name:'',
    is_referral:'',
    prefer_language:'',
  };

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
    return emailPattern.test(email);
  };

  const validateMobile = (mobile) => {
    const mobilePattern = /^(?:\+971|971|0)\d{9}$/; // Mobile number regex
    return mobilePattern.test(mobile);
  };

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(intialFormData);

  const generateTicketNumber = () => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';

    let ticketNumber = '';

    for (let i = 0; i < 6; i++) {
      if (i % 2 === 0) {
        ticketNumber += letters.charAt(Math.floor(Math.random() * letters.length));
      } else {
        ticketNumber += digits.charAt(Math.floor(Math.random() * digits.length));
      }
    }

    return ticketNumber;
  };

  const API_URL = process.env.NEXT_PUBLIC_API_URL;
  const API_TOKEN = process.env.NEXT_PUBLIC_API_TOKEN;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);



    const requiredFields = ['name', 'email', 'mobile', 'time', 'is_referral', 'prefer_language'];
    for (let field of requiredFields) {
      if (!formData[field] || formData[field].trim() === '') {
        alert(`Please enter your ${field.replace('_', ' ')}`);
        setLoading(false);
        return;
      }
    }

    if (formData.is_referral === 'yes' && (!formData.agent_name || formData.agent_name.trim() === '')) {
      alert('Agent name is required when referral is yes.');
      setLoading(false);
      return;
    }
    const ticket_number = generateTicketNumber();

    try {
      const formDataWithTicket = {
        ...formData,
        ticket_number,
      };

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${API_TOKEN}`,
        },
        body: JSON.stringify(formDataWithTicket),
      });


      if (!response.ok) {
        const errorText = await response.text();
        throw new Error('API request failed');
      }

      let data;

      try {
        data = await response.json();
      } catch (e) {
        console.error('Failed to parse JSON:', e);
      }


      if (response.ok) {
        try {
          await fetch('/api/openhouse/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },

            body: JSON.stringify({
              name: formData.name,
              email: formData.email,
              message:
                `
                <div style="
                    position: relative;
                    max-width: 500px;
                    margin: 0 auto;
                    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
                                url('https://images.x-space.ae/assets/images/Sobha/Sobha.webp') no-repeat center center;
                    background-size: cover;
                    padding: 20px;
                    color: white;
                    border-radius: 8px;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    font-family: Arial, sans-serif;">

                    <p style="font-size: 20px; color: white; text-align: center; margin-bottom: 10px;">Sobha Realty</p>
                    <p style="font-weight: bold; font-size: 40px; color: #0891b2; text-align: center; margin-top: 10px;">WHITE FRIDAY <br/>OPEN HOUSE</p>
                
                    <h2 style="text-align: center; color: white; font-weight: normal; font-size: 19px; letter-spacing: 4px; margin-bottom: 3rem;">THANK YOU FOR REGISTERING <br/> YOUR INTEREST</h2>
                
                    <p style="text-align: center; font-size: 16px; color: white; line-height: 1.6; margin: 10px 0;">Dear <strong>${formData.name}</strong></p>
                    <p style="text-align: center; font-size: 20px; color: white; line-height: 1.6; margin: 10px 0;">Ticket No</p>
                    <p style="border-radius: 10px; text-align: center; font-size: 24px; background-color: #0891b2; color: black; line-height: 1.6; margin: auto; padding: 15px; width: fit-content;">${ticket_number}</p>
                    <p style="font-size: 18px; color: white; line-height: 1.6; margin-top: 20px; margin-bottom: 6px; text-align: center;">Confirmation Date & Time</p>
                    <p style="font-size: 23px; color: white; line-height: 1.6; margin-top: 0px; text-align: center;">29 Nov 2024, ${formData.time}</p>
                
                    <div style="padding: 15px; border-radius: 5px; text-align: center;">
                        <p style="font-size: 14px; color: white; margin: 10px 0;">XSPACE REAL ESTATE</p>
                        <p style="font-size: 14px; color: white; margin: 10px 0;">Thank you for your booking! We look forward to serving you.</p>
                        <p style="font-size: 14px; color: white; margin: 10px 0;">
                            If you have any questions, feel free to <a href="https://x-space.ae/contact-us" style="color: #2980b9; text-decoration: none;">contact us</a>.
                        </p>
                    </div>
                    <footer style="font-size: 12px; color: white; text-align: center;">
                        <p style="margin: 5px 0; text-align: center;">&copy; 2024 X-Space Real Estate. All Rights Reserved.</p>
                        <p style="margin: 5px 0; text-align: center;">
                            <a href="https://x-space.ae/cookies-policy" style="color: white; text-decoration: none;">Privacy Policy</a> |
                            <a href="https://x-space.ae/cookies-policy" style="color: white; text-decoration: none;">Terms of Service</a>
                        </p>
                    </footer>
                </div>
                `,
            }),

          });

        }catch (e){
          console.error(e);
        }
        router.push('/sobha-openhouse-interest/thank-you');
        setFormData(intialFormData);

      } else {
        console.error('Submission error:', data);
        alert('Form submission failed.');
      }
    } catch (error) {
      console.error('Error during form submission:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);

    }
  };

  return (
    <>

      <form
        onSubmit={handleSubmit}
        autoComplete='off'
        autoFocus={true}
        className='bg-opacity-20 bg-white flex flex-col gap-4 items-center justify-center w-fit p-10 mobile:p-6 mobile:mb-4 rounded-3xl z-10'
      >
        {step === 1 && (
          <>
            <div className='flex flex-col gap-1 w-full'>
              <label className='text-white' htmlFor='name'>Name</label>
              <input
                required
                type='text'
                name='name'
                value={formData.name}
                onChange={handleChange}
                className='rounded-xl bg-opacity-35 bg-black placeholder:text-white text-white border border-primarycolor focus:outline-none focus:ring-1 focus:ring-primarycolor focus:border-transparent px-4 py-2'
              />
            </div>

            <div className='flex flex-col gap-1 w-full'>
              <label className='text-white' htmlFor='email'>Email</label>
              <input
                required
                type='email'
                name='email'
                value={formData.email}
                onChange={handleChange}
                className='rounded-xl bg-opacity-35 bg-black placeholder:text-white text-white border border-primarycolor focus:outline-none focus:ring-1 focus:ring-primarycolor focus:border-transparent px-4 py-2'
              />
            </div>

            <div className='flex flex-col gap-1 w-full'>
              <label className='text-white' htmlFor='mobile'>Mobile</label>

              <input
                required
                type='tel'
                name='mobile'
                maxLength={15}
                placeholder='e.g. +971 5XX XXX XXX'
                value={formData.mobile}
                onChange={handleChange}
                className='rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border border-primarycolor focus:outline-none focus:ring-2 focus:ring-primarycolor focus:border-transparent px-4 py-2'
              />
            </div>
            <button
              type='button'
              onClick={() => {
                if (!validateEmail(formData.email)) {
                  alert('Please enter a valid email address');
                  return;
                }

                if (!validateMobile(formData.mobile)) {
                  alert('Please enter a valid mobile number');
                  return;
                }

                setStep(2);
              }}
              className='bg-primarycolor border border-primarycolor text-white px-6 py-2 rounded-md mt-4 hover:bg-opacity-80'
            >
              Next
            </button>
          </>
        )}
        {step === 2 && (
          <>
            <div className='flex flex-col gap-1 w-full'>
              <label className='text-white' htmlFor='time-slot'>Timeslot</label>
              <select
                required
                name='time'
                value={formData.time}
                onChange={handleChange}
                className='rounded-xl bg-opacity-35 bg-black text-white border border-primarycolor focus:border-primarycolor focus:ring-primarycolor focus-within:bg-black focus-within:bg-opacity-35 focus:bg-black focus:bg-opacity-40 px-4 py-2 transition-all duration-200 ease-in-out'
              >
                <option value=''>Select a timeslot</option>
                <option value='10:00 - 11:00'>10:00 - 11:00</option>
                <option value='11:00 - 12:00'>11:00 - 12:00</option>
                <option value='12:00 - 13:00'>12:00 - 13:00</option>
                <option value='13:00 - 14:00'>13:00 - 14:00</option>
                <option value='14:00 - 15:00'>14:00 - 15:00</option>
                <option value='15:00 - 16:00'>15:00 - 16:00</option>
                <option value='16:00 - 17:00'>16:00 - 17:00</option>
                <option value='17:00 - 18:00'>17:00 - 18:00</option>
              </select>
            </div>

            <div className='flex flex-col gap-1 w-full'>
              <label className='text-white' htmlFor='name'>Prefer Language</label>
              <input
                required
                type='text'
                name='prefer_language'
                value={formData.prefer_language}
                onChange={handleChange}
                className='rounded-xl bg-opacity-35 bg-black placeholder:text-white text-white border border-primarycolor focus:outline-none focus:ring-1 focus:ring-primarycolor focus:border-transparent px-4 py-2'
              />
            </div>

            <div className='flex flex-col gap-2 w-full'>
              <label className='text-white' htmlFor='referral-agents'>
                Referral By Agent
              </label>
              <div className='flex ml-4 items-center gap-6'>
                <label className='flex items-center gap-2 text-white cursor-pointer'>
                  <input
                    type='radio'
                    name='is_referral'
                    value='yes'
                    onChange={handleChange}
                    className='hidden peer'
                    onClick={() => {
                      setShow(true);
                    }}
                  />
                  <div
                    className='w-5 h-5 border-4 border-primarycolor rounded-full flex items-center justify-center peer-checked:bg-white'>
                    <div className='w-2.5 h-2.5 bg-white rounded-full hidden peer-checked:block'></div>
                  </div>
                  Yes
                </label>

                <label className='flex items-center gap-2 text-white cursor-pointer'>
                  <input
                    type='radio'
                    name='is_referral'
                    value='no'
                    onChange={handleChange}
                    className='hidden peer'
                    onClick={() => {
                      setShow(false);
                    }}
                  />
                  <div
                    className='w-5 h-5 border-4 border-primarycolor rounded-full flex items-center justify-center peer-checked:bg-white'>
                    <div className='w-2.5 h-2.5 bg-white rounded-full hidden peer-checked:block'></div>
                  </div>
                  No
                </label>
              </div>
            </div>
            {show && (
              <div className='flex flex-col gap-1 w-full'>
                <label className='text-white' htmlFor='name'>Agent Name</label>
                <input
                  required={formData.is_referral === 'yes'}
                  type='text'
                  name='agent_name'
                  onChange={handleChange}
                  value={formData.agent_name}
                  className='rounded-xl bg-opacity-35 bg-black placeholder:text-white text-white border border-primarycolor focus:outline-none focus:ring-1 focus:ring-primarycolor focus:border-transparent px-4 py-2'
                />
              </div>
            )}

            <button
              type='submit'
              className='bg-primarycolor border border-primarycolor text-white px-6 py-2 rounded-md mt-4 hover:bg-opacity-80'
            >
              {loading ?
                <Stack spacing={2} direction='row' alignItems='center'>
                  <CircularProgress color='inherit' size='25px'/>
                </Stack>
                : 'Submit'}

            </button>
          </>
        )}
      </form>

    </>
  );
};

export default Interestform;